import { keyframes } from '@emotion/react';
import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import VolumeUpRoundedIcon from '@mui/icons-material/VolumeUpRounded';
import { IconButton } from '@mui/material';
import React from 'react';
import { BLUE, RING_TRACK } from '../studentStyles';

const audioPulse = keyframes`
    0% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.15); opacity: 0.7; }
    100% { transform: scale(1); opacity: 1; }
`;

interface AudioPlayButtonProps {
    ariaLabel: string;
    size?: number;
    durationMs?: number;
}

// Fake audio playback: shows a transient "playing" pulse instead of real sound.
export default function AudioPlayButton({ ariaLabel, size = 44, durationMs = 1600 }: AudioPlayButtonProps) {
    const [playing, setPlaying] = React.useState(false);
    const timeoutRef = React.useRef<number>();

    React.useEffect(() => () => window.clearTimeout(timeoutRef.current), []);

    const handleClick = () => {
        window.clearTimeout(timeoutRef.current);
        setPlaying(true);
        timeoutRef.current = window.setTimeout(() => setPlaying(false), durationMs);
    };

    const iconSize = Math.round(size * 0.55);
    return (
        <IconButton
            aria-label={ariaLabel}
            onClick={handleClick}
            sx={{
                width: size,
                height: size,
                color: BLUE,
                border: `1px solid ${RING_TRACK}`,
                backgroundColor: playing ? `${BLUE}14` : 'transparent',
                flexShrink: 0,
            }}
        >
            {playing
                ? <VolumeUpRoundedIcon sx={{ fontSize: iconSize, animation: `${audioPulse} 900ms ease-in-out infinite` }} />
                : <PlayArrowRoundedIcon sx={{ fontSize: iconSize }} />}
        </IconButton>
    );
}
